import { Component, Node, Vec2, Vec3, _decorator } from 'cc';
import RoadmapItem from './RoadmapItem';
import ItemGenerator from '../../../../../common/scripts/Toolkit/Components/Misc/ItemGenerator';
import { RoadmapData } from '../../../Data/Strategy/RoadmapLayout/BaseRoadmapLayoutStrategy';

enum EventType {
    ROADMAP_ITEM_CLICK = 'ROADMAP_ITEM_CLICK',
}

const { ccclass, property } = _decorator;

@ccclass('Roadmap')
export default class Roadmap extends Component {
    public static readonly EVENT_TYPE = EventType;

    @property
    public readonly size: Vec2 = new Vec2();

    @property(ItemGenerator)
    protected readonly itemGenerator: ItemGenerator = null;

    @property
    protected readonly startPosition: Vec3 = new Vec3();

    @property
    protected readonly spacing: Vec2 = new Vec2();

    protected readonly roadmapItemMap: Map<Node, RoadmapItem> = new Map();

    public display(data: RoadmapData) {
        const dataList = data.map((road) => road.itemDataList).flat();
        this.itemGenerator.displayItemCount = dataList.length;
        this.itemGenerator.items.forEach((item, index) => {
            item.setPosition(
                this.startPosition.x + this.spacing.x * dataList[index].position.x,
                this.startPosition.y - this.spacing.y * dataList[index].position.y,
                this.startPosition.z,
            );
            this.getRoadmapItem(item).display(dataList[index]);
        });
    }

    protected getRoadmapItem(node: Node) {
        let roadmapItem: RoadmapItem = this.roadmapItemMap.get(node);
        if (!this.roadmapItemMap.has(node)) {
            roadmapItem = node.getComponent('RoadmapItem') as RoadmapItem;
            if (!roadmapItem) {
                throw new Error('RoadmapItem component not found.');
            }
            this.roadmapItemMap.set(node, roadmapItem);
        }
        return roadmapItem;
    }
}
